import ThemeConfig from "@mobiusjs/superfon-new-site-client/dist/client/ThemeConfig";

export default ThemeConfig.customize(ThemeConfig, {
    styles: ['fonts/fonts', 'splide', 'theme', 'snow', 'custom/style'],
    scripts: ['runtime', 'common', 'lib1', 'lib2', 'lib3', 'mobius', 'theme']
});
